<template>
    
    <div  class="  ac-transition">
        <div class="card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
        </div>
        <div class="grid grid-cols-12">
  <div id="receipt"  class="receipt">
    <div class="receipt-container  ">
      <!-- <h3 class="dn_f_only text-center"><strong>Samarth Tailoring & Cutpiece </strong></h3>
      <p class="dn_f text-sm text-center">Akkalkot Road MIDC,Solapur</p>
      <p class="dn_f text-sm text-center">📞 8788133861 </p> -->
      <div class="border"></div>
      <!--<table class="receipt-table">-->
      <!--          <tr> -->
      <!--          <td style="font-size:12px;">-->
      <!--              <strong>Order No</strong> : {{invDetails.id}}-->
      <!--          </td>-->
      <!--          <td style="font-size:12px;">-->
      <!--              <strong>Date</strong> : {{invDetails.entry_date}}-->
      <!--          </td>-->
      <!--          </tr>-->

      <!--          <tr> -->
      <!--          <td style="font-size:12px;">-->
      <!--              <strong>Name</strong> : {{customer.name}}-->
      <!--          </td>-->
      <!--          <td style="font-size:12px;">-->
      <!--              <strong>Contact</strong> : {{customer.cell || 'No Contact'}}-->
      <!--          </td>-->
      <!--          </tr>-->

              
      <!--       <tr style="font-size:12px;">  -->
                    <!--<td  ><strong class="">Contact</strong> : {{customer.cell}}</td>-->
                    
                    
      <!--    </tr>-->
          
      <!--</table>     -->
   <!-- <div v-for="(item, index) in order_items_under" :key="item.id" style="margin-bottom: 6px; font-family: Arial, sans-serif; font-size: 14px; color: #333; border-top: 1px dotted #ccc; padding-top: 6px;"> -->

    <div v-for="(item, index) in order_items_under" :key="item.id" class="border">
           <table class="receipt-table">
                <tr> 
                <td style="font-size:12px;">
                    <strong>Order No</strong> : {{invDetails.id}}
                </td>
                <td style="font-size:12px;">
                    <strong>Date</strong> : {{invDetails.entry_date}}
                </td>
                </tr>

                <tr> 
                <td style="font-size:12px;" colspan="2">
                    <strong>Name</strong> : {{customer.name}}
                </td>
                <!--<td style="font-size:12px;">-->
                    <!--<strong>Contact</strong> : {{customer.cell || 'No Contact'}}-->
                <!--</td>-->
                </tr>

              
             <tr style="font-size:12px;">  
                    <!--<td  ><strong class="">Contact</strong> : {{customer.cell}}</td>-->
                    
                    
          </tr>
          
      </table>     

       <div v-if="item.measurements[0]?.stitch_type == 1">
        <strong>{{ index + 1 }}. {{ item.order_items.stich_name }}</strong>
        ({{ item.order_items.qty }}) {{ item.order_items.prd_name }} <br>
            {{ item.order_items.delv_on == '0000-00-00' ? '(No Date)' : item.order_items.delv_on }}  

           
              <div style="display: flex; flex-wrap: wrap;">
              <template v-for="(item_measure, index) in item.measurements" :key="index">
                <span style="margin-right: 10px;">
                  {{ item_measure.lablevalue || 'No Value' }}
                </span>
                
                <!-- Force a break to next line after specific indexes -->
                <span v-if="[0, 3, 6, 7, 11, 12, 13].includes(index)" style="flex-basis: 100%; height: 0;"></span>
              </template>
            </div>
          </div>

          
      <div v-else>
        <strong>{{ index + 1 }}. {{ item.order_items.stich_name }}</strong>
        ({{ item.order_items.qty }}) {{ item.order_items.prd_name }} <br>

            {{ item.order_items.delv_on == '0000-00-00' ? '(No Date)' : item.order_items.delv_on }}  

           
              <div style="display: flex; flex-wrap: wrap;">
              <template v-for="(item_measure, index) in item.measurements" :key="index">
                <span style="margin-right: 10px;">
                 {{ item_measure.lablevalue || 'No Value' }}
                </span>
                
                <!-- Force a break to next line after specific indexes -->
                <span v-if="[0,1,2,3,5,6,7].includes(index)" style="flex-basis: 100%; height: 0;"></span>
              </template>
            </div>
          </div>
  




 <div class="note_for_item">{{ item.order_items.measurementnote || 'No Note' }}</div>

        </div>

        <div v-if="invDetails?.delivery" style="margin-top: 12px; font-family: Arial, sans-serif; font-size: 14px; font-weight: bold;" class="border">
          Delivery Date: {{ invDetails.delivery }}
        </div>
 
       <!-- <p class="dn_f text-sm text-center">Thank You, Visit Again...!</p> -->
    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '',
      customer:[],
      invDetails:[],
      order_items:[], 
      order_items_under:[],
      measurements:[],
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() { 
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
             axios.post('getsinglemeasurementprint',{invoiceid:invoiceid}).then(function (response) {
                         self.order_items=response.data.order_items;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                        self.order_items_under=response.data.order_items_details;
                        try {
                            document.getElementById("loader").remove();  
                           self.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                      
                        
                         self.printReceipt();
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },


 getItemStyle(index) {
                    if (index === 0) {
                    return {
                        flex: '0 0 100%'  // Full width for first item
                    }
                    }else if(index === 4){
                  
                        return {
                        flex: '0 0 100%'  // Full width for first item
                    }
                    }else if(index === 5){
                  
                        return {
                        flex: '0 0 100%'  // Full width for first item
                    }
                    }else if(index === 8){
                  
                        return {
                        flex: '0 0 100%'  // Full width for first item
                    }
                }else if(index === 9){
                  
                        return {
                        flex: '0 0 100%'  // Full width for first item
                    }
                }
                    return {
                    flex: '1 1 calc(33.333% - 10px)'  // Three items per row, accounting for gap
                    };
                },










  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@200;500&display=swap');
.dn_f { 
  font-family: 'Noto Sans Devanagari', sans-serif;
  font-size: 14px;
}
.dn_f_only { 
  font-family: 'Noto Sans Devanagari', sans-serif;
}
tbody,table,.border{
    border-bottom: 1px dashed;
}
 #receipt {
  font-family: monospace;
  font-size: 16px;
  width: 68mm; /* Common width for thermal printers */
  padding: 5px;
}
table {
  width: 100%;
}
td, th {
  padding: 5px;
  text-align: left;
}


@media print {
    .note_for_item{
        text-wrap-mode: wrap;
    }
  button {
    display: none;
  }
 body {
        margin: -2rem 0 0 0;
        }
 #receipt {
   width: 250px; /* Ideal for thermal printers */
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  padding: 5px;
  
  /*border: 1px solid #000;*/
  margin: 0 auto;
  margin-top: -40px ;
  margin-left: 10px ;
  white-space: nowrap; /* Prevent text wrapping */
    }
    
    .dn_f_only{
      font-size: 16px;
      font-weight: 800;
    }
    .dn_f{
      font-size: 14px;
      
    }
}





</style>
